// @flow

import * as React from 'react';
import {ButtonLink} from 'sail/Button';
import {useAccount} from 'docs/data';
import {createStripeInternalUrl} from 'docs/util';

type VSCodeButtonProps = {|
  path: string,
  label?: React.Node,
|};

export const VSCodeButton = ({path, label}: VSCodeButtonProps) => {
  const {account} = useAccount();

  if (!account?.xray?.username) {
    return null;
  }

  const {username} = account.xray;
  const href = createStripeInternalUrl('vscode', {
    username,
    root: 'docs/content/',
    filename: path,
  });

  return (
    <ButtonLink
      href={href}
      label={label ?? 'Open in VSCode'}
      display="inline-flex"
      icon="external"
      iconPosition="right"
      target="_blank"
    />
  );
};
